// Keep the existing cart link and its live count reachable as the header leaves
// the viewport. Product forms confirm additions without navigating away.
const headerRow = document.querySelector('.mz-header__main');
const cartLink = headerRow?.querySelector('.mz-bag');

if (headerRow && cartLink) {
  const observer = new IntersectionObserver(([entry]) => {
    if (!entry) return;
    cartLink.classList.toggle('mz-bag--floating', entry.boundingClientRect.top < 0);
  }, { threshold: [0, 1] });

  observer.observe(headerRow);
}
